module.exports = (function() {
	global.filterData = [];

   	$('.filter-module').each(function() {
   		var element = $(this);
   		var name = $(this).attr('data-name');
   		var container = $(this).find('.list-container');
   		var perPage = typeof($(container).attr('data-per-page')) !== 'undefined' ? $(container).attr('data-per-page') : 9;
   		var itemIds = typeof($(container).attr('data-item-ids')) !== 'undefined' ? $(container).attr('data-item-ids') : '';

   		global.filterData[name] = [];
      global.filterData[name]['pageLoad'] = true;
   		global.filterData[name]['data'] = [];
   		global.filterData[name]['filterData'] = [];
      global.filterData[name]['currentPage'] = 1;
   		global.filterData[name]['perPage'] = perPage;
   		global.filterData[name]['filterData']['itemIds'] = itemIds;

   		setDeepLinks(true, $(this));

   		loadData(element);
   		setupFilters(element);      
   	});

   	setupHashChangeEvent();
})();

function setDeepLinks(onload, element) {
  	var hasPagination = $(element).find('.pagination').length > 0;
   	var hasPaginationLoadMore = $(element).find('.pagination-load-more').length > 0;

   	if (hasPagination) {
   		setDeepLinkPage(onload, element);
   	}

   	$(element).find('.filter-input').each(function() {
   		setDeepLinkFilterCategory(element, $(this));
   	});

   	setDeepLinkSelectedFilter(element);
}

function setDeepLinkPage(onload, element) {
    var pageHash = getHashParams();
    var name = $(element).attr('data-name');

    global.filterData[name]['currentPage'] =1;
    if (!onload && typeof(pageHash.page) !== 'undefined') {
       global.filterData[name]['currentPage'] = parseInt(pageHash.page);
    }
}

function setDeepLinkFilterCategory(element, category) {
    var pageHash = getHashParams();
    var name = $(element).attr('data-name');
    var catName = $(category).attr('name');

    global.filterData[name]['filterData'][catName] = formatSelectVal(element, '[name="'+catName+'"]');
    if (typeof(pageHash[catName]) !== 'undefined') {
        global.filterData[name]['filterData'][catName] = pageHash[catName];
        if (typeof(pageHash[catName]) == 'undefined' || pageHash[catName].length == 0) {
            $(element).find('[name="'+catName+'"] option').eq(0).prop('selected', true);
        }
        else {
            $(element).find('[name="'+catName+'"]').val( global.filterData[name]['filterData'][catName]);
        }
    }
}

function setDeepLinkSelectedFilter(element) {
	var name = $(element).attr('data-name');
	var foundSelected =false;
	var selectedName = '';

	$(element).find('.filter-category').each(function() {
		var category = $(this);
   	var catName = category.attr('name');
		var value = typeof(global.filterData[name]['filterData'][catName]) !== 'undefined' ? global.filterData[name]['filterData'][catName] : '';
		if (value && !foundSelected) {
			foundSelected = true;
			selectedName = 'catName';
		}
	});

	if (foundSelected) {
		$(element).find('.filter-category').removeClass('selected');
		$(element).find('.filter-inputs').show();
		$(element).find('.filter-input').hide();
		$(element).find('.filter-category[data-category="'+selectedName+'"]').addClass('selected');
		$(element).find('.filter-input[data-category="'+selectedName+'"]').show();
	}
}

function loadData(element) {
	var name = $(element).attr('data-name');
	var url = getDataUrl(element);
  if (url.length > 0) {
  	url += getDataUrlArguments(element);
    $.ajax({
        url:url,
        dataType: "text",
        success: function(data) {
            var json = $.parseJSON(data);            
            global.filterData[name]['data'] = setCustomData(element,json);
            setupDataList(element);
            setupPagination(element);
        },
        error: function(e) {
            toggleNoResultsMessage(element,true);
        }
    });
  }
}

function setCustomData(element, data) {
  var name = $(element).attr('data-name');
  switch(name) {
    case 'program-categories-filter':    
      var selectedCategory = $(element).find('.filter-category.selected').attr('data-category');
      data['page2Heading'] = selectedCategory == "category" ? $('[name="page-2-heading-campus"]').val() : $('[name="page-2-heading-category"]').val();      
    break;
    case 'other-courses-filter':
      data['buttonText'] =  $('[name="button-text"]').val(); 
    break;
  }

  return data;
}

function setupDataList(element) {
    var name = $(element).attr('data-name');
    var container = $(element).find('.list-container');
	  var totalResults = getTotalResults(element);
    var data = getData(element);
    var templateUrl = getTemplateUrl(element);
    var perPage = global.filterData[name]['perPage'];
    var pageLoad = global.filterData[name]['pageLoad'];

    toggleNoResultsMessage(element,data.length == 0);

    if (templateUrl.length > 0) {
	    $.get(templateUrl , function (result) {
	        var template = _.template(result);
	        var html = template(global.filterData[name]['data']);
          if (hasPaginationLoadMore(element)) {
	         $(container).append(html);
          }
          else {
            $(container).html(html);
          }

          setupPostLoadEvents(element);

	        if (!pageLoad && totalResults > perPage && hasPagination(element)) {
	        	if (hasPaginationLoadMore(element)) {
	            	moveWindowToElement($('.list-data-page:last'),0,800);
	            }
	            else {
	            	moveWindowToElement($(container),0,800);
	            }
	        }

          global.filterData[name]['pageLoad'] = false;
	    }, 'html');
    }

}

function getDataUrlArguments(element) {
  var language = $("meta[name='site-language']").attr('content');
	var name = $(element).attr('data-name');
	var args = "?currentPage=" + global.filterData[name]['currentPage'];
  var selectedCategory = $(element).find('.filter-category.selected');
  selectedCategory = $(selectedCategory).length > 0 ? $(selectedCategory).attr('data-category') : '';

	$(element).find('.filter-input').each(function() {
		  var category = $(this);
      var catName = category.attr('data-category');
   		var nameC = category.attr('name');
   		var value = typeof(global.filterData[name]['filterData'][nameC]) !== 'undefined' ? global.filterData[name]['filterData'][nameC] : '';
      if (catName == selectedCategory) {
   		  args += '&' + nameC + '=' + value;
      }
      else {
        args += '&' + nameC + '=';
      }
	});

	args += '&itemIds=' +  global.filterData[name]['filterData']['itemIds'];
  args += '&language=' + language;
	return args;
}

function getDataUrl(element) {
	var name = $(element).attr('data-name');
	var selector = '';
	switch(name) {
		case 'short-courses-filter':
			selector = "meta[name='short-courses-data-url']";
			break;
		case 'program-categories-filter':
			selector = "meta[name='program-categories-data-url']";
			break;
    case 'other-courses-filter':
      selector = "meta[name='other-courses-data-url']";
      break;
    case 'news-events-filter':
      selector = "meta[name='news-events-data-url']";
      break;
    case 'brochures-filter':
      selector = "meta[name='brochures-data-url']";
      break;
	}

	if (selector.length > 0) {
		return formatDataUrl(element, $(selector).attr('content'));
	}

	return '';
}

function getTemplateUrl(element) {
	var siteRoot = $("meta[name='site-root']").attr('content');
	var name = $(element).attr('data-name');
	switch(name) {
		case 'short-courses-filter':
			return siteRoot + 'templates/short-courses.html';
		case 'program-categories-filter':
			return siteRoot + 'templates/program-categories.html';
    case 'news-events-filter':
      return siteRoot + 'templates/news-events.html';
    case 'other-courses-filter':
      return siteRoot + 'templates/other-courses.html';
    case 'brochures-filter':
      if ($(element).find('.brochures-form').length == 0) {
        return siteRoot + 'templates/brochures.html';
      }
      else {
        return siteRoot + 'templates/brochures-form.html';
      }
	}

	return '';
}

function getFilterHashUrl(element, pageVal) {
    var url = '#page=' + pageVal;
    var selectedCategory = $(element).find('.filter-category.selected');
    selectedCategory = $(selectedCategory).length > 0 ? $(selectedCategory).attr('data-category') : '';

    $(element).find('.filter-input').each(function() {
      var category = $(this);
      var catName = category.attr('data-category');
      var name = category.attr('name');
      if (catName == selectedCategory) {
        url += '&' + name + '=' + formatSelectVal(element, '[name="'+name+'"]');
      }
      else {
        url += '&' + name + '=';
      }
    });

    url +=  "&rand=" + (new Date).getTime();

    return url;
}

function setupHashChangeEvent() {
    window.onhashchange = function() {
      $('.filter-module').each(function() {
          setDeepLinks(false, $(this));
          loadData($(this));
      });
    }
}

function setupPagination(element) {
	var name = $(element).attr('data-name');
	var siteRoot = $("meta[name='site-root']").attr('content');
  var totalResults = getTotalResults(element);
  var totalPages = Math.ceil(parseInt(totalResults)/parseInt(global.filterData[name]['perPage']));

  global.filterData[name]['currentPage'] = global.filterData[name]['currentPage'] <= totalPages ? global.filterData[name]['currentPage'] : totalPages;

	if (hasPaginationLoadMore(element)) {
        $.get( siteRoot + 'templates/pagination-load-more.html', function (result) {
            var template = _.template(result);
            var html = template({currentPage:global.filterData[name]['currentPage'], totalPages:totalPages, pageUrl:getFilterHashUrl(element,'{page}')});
            $(element).find('.pagination-load-more').html(html);
        }, 'html');
	}
	else if (hasPagination(element)) {
        $.get( siteRoot + 'templates/pagination.html', function (result) {
            var template = _.template(result);
            var html = template({currentPage:global.filterData[name]['currentPage'], totalPages:totalPages, pageUrl:getFilterHashUrl(element,'{page}')});
            $(element).find('.pagination').html(html);
        }, 'html');
	}
}

function setupFilters(element) {
    var selectedCategory = $(element).find('.filter-category.selected');
    selectedCategory = selectedCategory.length > 0  ? $(selectedCategory).attr('data-category') : 'all';

    if (selectedCategory != 'all') {
        toggleSelectedFilterCategory(element, selectedCategory);
    }

    $(element).find('.filter-input').change(function() {
    	var container = $(element).find('.list-container');
    	$(container).empty();
        window.location.hash = getFilterHashUrl(element,1);
    });

    $(element).find('.filter-category').click(function() {
    	var category = $(this).attr('data-category');
    	toggleSelectedFilterCategory(element,category);
    });
}

function toggleSelectedFilterCategory(element, category) {

    $(element).find('.filter-category').removeClass('selected');
    $(element).find('.filter-category[data-category="'+category+'"]').addClass('selected');
    switch(category) {
        case 'all':
            $(element).find('.list-container').show();
            $(element).find('.filter-inputs').hide();
            $(element).find('.filter-content').hide();
            $(element).find('.list-container').empty();
            if ($(element).find('.filter-input[data-category="'+category+'"]').length > 0) {
              $(element).find('.filter-input').hide();
              $(element).find('.filter-inputs').show();
              $(element).find('.filter-input[data-category="'+category+'"]').show();
            }
            window.location.hash = getFilterHashUrl(element, 1);
            break;
        default:
            $(element).find('.list-container').show();
            $(element).find('.filter-inputs').show();
            $(element).find('.filter-input').hide();
            $(element).find('.filter-content').hide();            
            $(element).find('.filter-input[data-category="'+category+'"]').show();
            break; 
    }
}

function toggleNoResultsMessage(element,toggleOn) {
	var container = $(element).find('.list-container');
	var containerNoResults = $(element).find('.no-results');
    if (toggleOn) {
        $(container).html('');
        $(containerNoResults).show();
    }
    else {
        $(containerNoResults).hide();
    }
}

function hasPagination(element) {
	return $(element).find('.pagination').length > 0;
}

function hasPaginationLoadMore(element) {
	return $(element).find('.pagination-load-more').length > 0;
}

function hasPaginationLoadMore(element) {
  return $(element).find('.pagination-load-more').length > 0;
}

function hasSpecificData(element) {
  var name = $(element).attr('data-name');
  return typeof(global.filterData[name]['filterData']['itemIds']) !== 'undefined' && global.filterData[name]['filterData']['itemIds'].length > 0;
}

function getTotalResults(element) {
	var name = $(element).attr('data-name');
	return typeof(global.filterData[name]['data']['totalResults']) !== 'undefined' ? global.filterData[name]['data']['totalResults'] : 0;
}

function getData(element) {
	var name = $(element).attr('data-name');
	return typeof(global.filterData[name]['data']['items']) !== 'undefined' ? global.filterData[name]['data']['items'] : [];
}

function formatDataUrl(element,url) {
	var name = $(element).attr('data-name');
    if (url.indexOf('{page}') >=0) {
        url = url.replace('{page}','-page-' + global.filterData[name]['currentPage'] + '-perpage-' + global.filterData[name]['perPage']);
    }
    return url;
}

function formatSelectVal(element, selector) {
    var val = $(element).find(selector).val();
    var result = val == null ? '' : val;
    return result;
}

function setupPostLoadEvents(element) {
  var name = $(element).attr('data-name');
  switch(name) {
    case 'brochures-filter':
      $(document).foundation();
      setupBrochuresForm();
      break;
  }
}

function configureSlider(element) {
  var slider = $(element).find('.flexslider');
  window.slides[$(slider).attr('data-slider-name')] = $(slider).find('li').clone();
  loadSlider( $(slider), $(slider).attr('data-slides-to-show'));
}


function setupProgramCategoriesEvents() {
    $('.location-toggle').off('click');
    $('.close-page-2').off('click');

    $('.location-toggle').click(function() {
      toggleProgramCategoryLocations($(this));
    });

    $('.close-page-2').click(function() {
      toggleProgramCategoryLocations($(this));
    });
}

function setupBrochuresForm() {
  $('.brochures-form').find('.lcb-brochure-option').off('click');

  $('.brochures-form').find('.lcb-brochure-option').click(function() {
    $('.selected-brochures').val('');

    var selectedValues = '';
    $('.brochures-form').find('.lcb-brochure-option:checked').each(function() {
      selectedValues += $(this).val() + ',';
    });

    if (selectedValues.length > 0) {      
      $('.selected-brochures').val(selectedValues.substring(0,selectedValues.length - 1));
    }    
  });
}